import { conversationText, type ConversationTextCopy } from "@/lib/i18n/conversation-copy"

/** Canonical English for transcripts; UI descriptors carry a typed key alongside it. */
export function pauseOriginLabel(by: string | null | undefined): string {
  return conversationText(getPauseOriginCopy(by))
}

export function getPauseOriginCopy(by: string | null | undefined): ConversationTextCopy {
  switch (by) {
    case "ai_handover": return {key: "pauseEscalation"}
    case "operator_echo": return {key: "pauseOperatorReply"}
    case "crm_operator_reply": return {key: "pauseCrmOperator"}
    case "contact_exclusion": return {key: "pauseExcluded"}
    case "user": return {key: "pauseManual"}
    default: return {key: "pauseUnknown"}
  }
}
